export default "__VITE_ASSET__Cjwg40Jp__"